import React, { useState } from "react";
import { sidePane2VisibilityKey, sidePaneVisibilityKey } from "./index";
import InterpretationForm from "./InterpretationForm";
import Comments from "./Comments";
import { Button } from "primereact/button";

const DocsSwitcher = ({
  annotations,
  currentSondage,
  currentProject,
  currentDocNumber,
  setDocNumber,
  deleteOcr,
  formData,
  setFromData,
}) => {
  const parseBool = (value) => value === "true";
  const sidePaneVisible =
    parseBool(localStorage.getItem(sidePaneVisibilityKey)) ?? true;
  const sidePaneVisible2 =
    parseBool(localStorage.getItem(sidePane2VisibilityKey)) ?? true;
  const [visible, setVisible] = useState(sidePaneVisible);
  const [visible2, setVisible2] = useState(sidePaneVisible2);

  return (
    <div style={{ display: "flex" }}>
      {/* LEFT PANEL */}
      <div
        style={{
          position: "fixed",
          top: "59px",
          left: 0,
          width: "430px",
          height: "calc(100vh - 69px)",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "rgba(210, 210, 210, 0.0)",
          zIndex: 1000,
          minHeight: 0, // important for flex shrinking
        }}
      >
        <div>
          {/*<button onClick={() => window.location.reload()}>Refresh</button>*/}
          {visible && (
            <Button
              text
              icon="pi pi-chevron-circle-left"
              onClick={() => {
                localStorage.setItem(sidePaneVisibilityKey, false);
                setVisible(false);
              }}
            ></Button>
          )}

          {!visible && (
            <Button
              icon="pi pi-chevron-circle-right"
              className="p-button-secondary"
              onClick={() => {
                localStorage.setItem(sidePaneVisibilityKey, !visible);
                setVisible(!visible);
              }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1001,
              }}
            />
          )}
        </div>

        {currentSondage == null || currentSondage.documents == null ? (
          <p>No docs :/</p>
        ) : (
          visible && (
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: 0, // crucial for scroll to work properly
              }}
            >
              <Button
                icon="pi pi-external-link"
                label="Fiche de Sondage"
                onClick={() => window.open(currentSondage.sondage_url)}
                className="p-button-icon"
                style={{ height: "30px" }}
              />
              <button
                onClick={() => {
                  deleteOcr(currentSondage, currentDocNumber);
                }}
              >
                Relaunch OCR {currentSondage.id}
              </button>

              <table
                style={{
                  width: "100%",
                  border: "1px solid black",
                  backgroundColor: "rgba(210, 210, 210, 1.0)",
                  marginBottom: "0px",
                }}
              >
                <thead>
                  <tr>
                    <th>Documents ({currentSondage.documents.length})</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentSondage.documents.map((doc, nbr) => (
                    <tr key={nbr}>
                      <td
                        style={{
                          backgroundColor:
                            nbr === currentDocNumber
                              ? "lightblue"
                              : "lightgray",
                        }}
                      >
                        {doc.pdf_status.status === "success"
                          ? "✅"
                          : doc.pdf_status.status === "pending"
                            ? "⏳"
                            : "🍂"}
                        {doc.filename || doc.pdf_status.status}
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            if (doc.pdf_status.status !== "success") {
                              alert(
                                "Document not ready \nstatus: " +
                                  doc.pdf_status.status +
                                  "\nurl: " +
                                  doc.pdf_url +
                                  "\n\ntext:" +
                                  doc.pdf_status.text,
                              );
                            } else {
                              setDocNumber(nbr);
                            }
                          }}
                        >
                          Open
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Scroll container for InterpretationForm */}
              <div
                id={"yolooo"}
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: "auto",
                  border: "1px solid black",
                  backgroundColor: "rgba(210, 210, 210, 1.0)",
                  padding: "6px",
                }}
              >
                <InterpretationForm
                  currentProject={currentProject}
                  formData={formData}
                  setFromData={setFromData}
                />
              </div>

              {/* Comments fixed height at bottom */}
              <div style={{ borderTop: "1px solid gray" }}>
                <Comments sondageId={currentSondage._id} />
              </div>
            </div>
          )
        )}
      </div>

      {/* RIGHT PANEL */}
      {visible2 && (
        <div
          style={{
            position: "fixed",
            top: "69px",
            right: 0,
            zIndex: 1000,
            marginRight: "10px",
            width: "600px",
            height: "400px",
            border: "4px ridge black",
            backgroundColor: "rgba(210, 210, 210, 1.0)",
          }}
        >
          <button
            onClick={() => {
              localStorage.setItem(sidePane2VisibilityKey, false);
              setVisible2(false);
            }}
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1001,
            }}
          >
            ►
          </button>
          <iframe
            key={currentSondage?.sondage_url}
            src={currentSondage?.sondage_url || "about:blank"}
            width="100%"
            height="100%"
            title="Fiche sondage"
          />
        </div>
      )}

      {!visible2 && (
        <Button
          icon="pi pi-chevron-circle-left"
          className="p-button-secondary"
          onClick={() => {
            localStorage.setItem(sidePane2VisibilityKey, true);
            setVisible2(true);
          }}
          style={{
            position: "fixed",
            top: "59px",
            right: 0,
            zIndex: 1000,
            marginRight: "10px",
          }}
        />
      )}
    </div>
  );
};

export default DocsSwitcher;
